import { apiGet, apiPost } from '../utils/api';
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

const fetchEntities = async () => {
  const result = await apiGet('entities/get-users-entities');
  return Array.isArray(result) ? result : (result?.entities || []);
};

export const fetchEntitiesQuery = () =>
  useQuery({
    queryKey: ['entities'],
    queryFn: () => fetchEntities(),
  });

const createEntity = async (postBody) => {
  const res = await apiPost('entities/create-entity', postBody);
  return res;
};

export const createEntityMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['entities'] });
    },
  });
};

const getAnalytics = async (entityId, entityType) => {
  if (isNaN(parseInt(entityId))) return [];
  const postBody = { entity_id: entityId, entity_type: entityType };
  return await apiGet('entities/get-analytics', postBody);
};

export const getAnalyticsQuery = (entityId, entityType) =>
  useQuery({
    queryKey: ['statistics', entityId],
    queryFn: () => getAnalytics(entityId, entityType),
  });
